import axios from "../axios";

const api = {
  updateDimension({ id, data }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.post(`/dimensions/${id}`, data, config).then(({ data }) => data);
  },

  deleteDimension(id, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.delete(`/dimensions/${id}`, config).then(({ data }) => data);
  },

  reactivateDimension(id, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimensions/${id}/reactivate`, null, config).then(({ data }) => data);
  },

  createDimensionItem(data, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.post("/dimension-items", data, config).then(({ data }) => data);
  },

  updateDimensionItem({ id, data }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.post(`/dimension-items/${id}`, data, config).then(({ data }) => data);
  },

  deleteDimensionItem(id, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.delete(`/dimension-items/${id}/smart`, config).then(({ data }) => data);
  },

  reactivateDimensionItem(id, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimension-items/${id}/reactivate`, null, config).then(({ data }) => data);
  },

  getDimensionItemUsage(id, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.get(`/dimension-items/${id}/usage`, config).then(({ data }) => data);
  },

  getDimensionTree(accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.get("/dimensions/admin/tree", config).then(({ data }) => data);
  },

  addDimensionItem({ dimensionId, data }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimensions/${dimensionId}/items`, data, config).then(({ data }) => data);
  },

  addChildDimensionItem({ parentItemId, data }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimension-items/${parentItemId}/children`, data, config).then(({ data }) => data);
  },

  linkToParent({ parentId, childId }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimension-items/${parentId}/link/${childId}`, null, config).then(({ data }) => data);
  },

  unlinkFromParent({ parentId, childId }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.delete(`/dimension-items/${parentId}/link/${childId}`, config).then(({ data }) => data);
  },

  renameDimensionItem({ id, name }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimension-items/${id}/rename`, { name }, config).then(({ data }) => data);
  },

  renameDimension({ id, name }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimensions/${id}/rename`, { name }, config).then(({ data }) => data);
  },

  getMergePreview({ sourceId, targetId }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.get(`/dimension-items/${sourceId}/merge-preview/${targetId}`, config).then(({ data }) => data);
  },

  mergeDimensionItem({ sourceId, targetId }, accessToken) {
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };
    return axios.put(`/dimension-items/${sourceId}/merge/${targetId}`, null, config).then(({ data }) => data);
  },
};

export default api;
